import * as React from 'react';

import arrow from '../../../../assets/images/arrow-list.svg';

interface IProps {
    text: string;
}

export const VacancyItemList: React.FC<IProps> = ({ text }) => (
    <div className="list">
        <div className="list__item">
            <img src={arrow} alt="" />
        </div>
        <div className="list__text">
            <p>{text}</p>
        </div>
    </div>
);
